import { GrCheckmark, GrClose } from 'react-icons/gr';

import { MotionCardStyled } from './styled';

import clsx from 'clsx';

interface MotionCardProps {
  className?: string;
  title: string;
  success: number;
  fail: number;
}

const MotionCard = ({ className, title, success, fail }: MotionCardProps) => {
  return (
    <MotionCardStyled className={clsx('MotionCard', className)}>
      <div className="title">{title}</div>
      <div className="content">
        <div className="count success-count">
          <div className="icon">
            <GrCheckmark />
          </div>
          <div className="label">성공 횟수</div>
          <div className="value">{success}</div>
        </div>
        <div className="count fail-count">
          <div className="icon">
            <GrClose />
          </div>
          <div className="label">실패 횟수</div>
          <div className="value">{fail}</div>
        </div>
      </div>
    </MotionCardStyled>
  );
};

export default MotionCard;
